module.exports = __webpack_public_path__ + "img/yhj.cd6d346f.svg";